// Path: src\Components\More\Imageslider.jsx
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import SwiperCore from 'swiper';
import Bgmiimage1 from "../../images/box.png"; // Image 1
import { base_apis } from '../../config/url';

// Install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

const MySwiper = ({ data }) => {
  return (
    <div className="points-swiper0-slider">
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={6}
        loop={false}      
        initialSlide={Math.floor(data?.length / 2)} // Set the initial centered slide
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        pagination={{ clickable: true }}
        className="mySwiper"
      >
        {data?.map((game, index) => (
          <SwiperSlide key={index}>
            <div className='swipper-image-card'>
              <div>{game?.name}</div>
              <img 
                src={`${base_apis?.imageUrl}${game?.featuredImage?.default}`} 
                alt={game?.name || 'game image'} 
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MySwiper;
